import { Outlet } from "react-router-dom";
import { AppearanceProvider } from "./AppearanceProvider";

export default function LayoutProvider() {
  return (
    <AppearanceProvider>
      <Outlet />
    </AppearanceProvider>
  );
}